import React, { useState, useEffect } from 'react';
import styles from './rejectionEmailModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import CSSLoader from '../../../../shared/cssLoader';
import EmailReview from './emailReview';
import EmailDetails from './emailDetails';
import { getRejectEmailTemplateConfigs, submitRejectEmailTemplate } from '../../../../../services/util/hiringpipeline/emailAutomation';

function RejectionEmailModal(props) {
    let [step, setStep] = useState(1);
    let [pipelineValues, setPipelineValues] = useState(props.pipelineValues);
    let [emailData,setEmailData] = useState({
        templateWrapper:'',
        templateBody:null,
        email_subject:'',
        email_account_choice:null
    })
    let [isLoading, setLoading] = useState(false);
    let [isEmailActive, setIsEmailActive] = useState(false);
    let [submissionLoading,setSubmissionLoading] = useState(false);

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    const onSubmitEmailData = (values) =>{
        setEmailData((prevState) => ({
            ...prevState,
            templateBody: values.emailBody,
            email_subject: values.emailSubject

        }));
        nextPage(2);
    }

    const getInitialValues = async() =>{
        setLoading(true);
        let respond = await getRejectEmailTemplateConfigs(pipelineValues);
        if(respond.success === true){
            setEmailData(respond.data);
            setIsEmailActive(respond.data.is_reject_email_enable);
            setLoading(false);
        }else{
            setLoading(false);
        }
    }

    const submitEmailTemplateValues = async() =>{
        setSubmissionLoading(true);
        let respond = await submitRejectEmailTemplate(pipelineValues, emailData.email_subject, emailData.templateBody, isEmailActive);
        if(respond.success === true){
            setSubmissionLoading(false);
            props.handleClose();
            props.getPipelineValues();
        }else{
            setSubmissionLoading(false);
        }
    }

    useEffect(() => {
        getInitialValues();
    }, []);
    
    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body  className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Reject Email Template</h2>
                    </div>

                    <Col xs={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>1</div>
                            <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                        </div>
                    </Col>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        {
                            isLoading === false ?
                                (<Container className={styles.colWithNoSidePaddings}>
                                    {/* Rendering Content Goes Here */}
                                    {step === 1 && props.showModal === true && <EmailDetails isChecked={isEmailActive} setIsEmailActive={setIsEmailActive} onSubmitEmailData={onSubmitEmailData} closeModal={props.handleClose} emailData={emailData}/>}
                                    {step === 2 && props.showModal === true && <EmailReview previousPage={previousPage} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} emailData={emailData} isChecked={isEmailActive} submitEmailTemplateValues={submitEmailTemplateValues} submissionLoading={submissionLoading}/>}
                                </Container>)
                                : (<div className='mt-5'>
                                    <Col sm={{ span: 4, offset: 4 }}>
                                        <CSSLoader />
                                    </Col>
                                </div>)
                        }
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default RejectionEmailModal;
